import { i as validateReverificationConfig, n as resolveAuthState, r as splitByScope, t as createCheckAuthorization } from "./authorization-Un7v7f6J.mjs";

export { createCheckAuthorization, resolveAuthState, splitByScope, validateReverificationConfig };